import { useState, useEffect, useCallback, type MutableRefObject } from 'react';

export const useElementClientWidth = <T extends HTMLElement>({
  ref,
}: {
  ref: MutableRefObject<T | null>;
}): { width: number } => {
  const [width, setWidth] = useState<number>(ref?.current?.clientWidth || 0);

  const handleSetWidth = useCallback(() => {
    if (ref?.current) {
      setWidth(ref.current.clientWidth);
    }
  }, [ref]);

  useEffect(() => {
    if (!ref?.current) return;

    // Set width on initial render
    handleSetWidth();

    // ResizeObserver to track width changes
    const resizeObserver = new ResizeObserver(() => {
      handleSetWidth();
    });
    resizeObserver.observe(ref.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [ref, handleSetWidth]);

  return { width };
};
